(() => {
  'use strict';
  const hover = matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  function openArea(area) {
    const parentGroup=area.closest('.br-department-group');if(parentGroup)parentGroup.open=true;
    const group = area.closest('[data-br-departments]');
    group?.querySelectorAll('[data-br-expander][open]').forEach(other => { if (other !== area && !other.contains(document.activeElement)) other.open = false; });
    if (area.open) return;
    area.open = true;
    if (!reduced.matches) area.querySelector('.br-expander__body')?.animate([{opacity:.3,clipPath:'inset(0 0 30% 0)',transform:'translateY(-8px)'},{opacity:1,clipPath:'inset(0)',transform:'translateY(0)'}],{duration:440,easing:'cubic-bezier(.2,.7,.2,1)'});
  }
  function init(root = document) {
    root.querySelectorAll('[data-br-expander]').forEach(area => {
      if (initialized.has(area)) return;
      initialized.add(area);
      const trigger = area.querySelector('summary');
      let timer;
      trigger.addEventListener('pointerenter',e => { if (e.pointerType === 'mouse' && hover.matches) timer = setTimeout(()=>openArea(area),160); });
      trigger.addEventListener('pointerleave',()=>clearTimeout(timer));
      trigger.addEventListener('click',e => { clearTimeout(timer); if (!area.open) { e.preventDefault(); openArea(area); } });
    });
  }
  function showAnchor() {
    if (!location.hash) return;
    let target; try { target=document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
    if (target?.matches('[data-br-expander]')) openArea(target);
  }
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:block:select',e=>{const area=e.target.closest('[data-br-expander]');if(area)openArea(area);});
  window.addEventListener('hashchange',showAnchor);
  init(); showAnchor();
})();
